import React from 'react'

const TravellerDashboardMain = () => {
    return (
        <div className="sm:px-8 px-6 pb-5">
            <div className="grid my-4  grid-cols-1 gap-3 whitespace-nowrap">
                <h2 className='text-black font-roboto-mono text-[20px] font-bold' >
                    Traveller Dashboard
                </h2>
            </div>
        </div>
    )
}

export default TravellerDashboardMain
